import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API, useApi } from "@/lib/api";

const toUint8 = (b64) => {
  const raw = atob((b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

// Stato e attivazione delle notifiche push per i nuovi lead
export function usePushNotifications() {
  const api = useApi();
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!pushSupported()) return setState("unsupported");
    navigator.serviceWorker.ready.then((reg) => reg.pushManager.getSubscription()).then((sub) => {
      if (Notification.permission === "denied") setState("denied");
      else setState(sub ? "on" : "off");
    });
  }, []);

  const enable = useCallback(async () => {
    const perm = await Notification.requestPermission();
    if (perm !== "granted") return setState(perm === "denied" ? "denied" : "off");
    const reg = await navigator.serviceWorker.ready;
    const { key } = (await axios.get(`${API}/push/public-key`)).data;
    const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toUint8(key) });
    await api("post", "/push/subscribe", sub.toJSON());
    setState("on");
  }, [api]);

  const disable = useCallback(async () => {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      await api("post", "/push/unsubscribe", sub.toJSON());
      await sub.unsubscribe();
    }
    setState("off");
  }, [api]);

  return { state, enable, disable };
}
